import { NgModule } from '@angular/core';

import { DxDataGridModule } from 'devextreme-angular';

import { PipesModule } from 'src/app/common/pipes/pipes.module';
import { SharedModule } from 'src/app/shared.module';
import { DevPopUpModule } from '../dev-popup/dev-popup.module';
import { ActivitiesComponent } from './activities.component';
import { ActivitiesService } from './activities.service';
import { ActivitiesDisplayPopupComponent } from './shared/activities-display-popup/activities-display-popup.component';
import { ActivitiesDownloadedComponent } from './shared/activities-downloaded/activities-downloaded.component';
import { ActivitiesNavigateProfileComponent } from './shared/activities-navigate-profile/activities-navigate-profile.component';
import { ActivitiesPermissionChangedComponent } from './shared/activities-permission/activities-permission.component';
import { ActivitiesRemovedComponent } from './shared/activities-removed/activities-removed.component';
import { ActivitiesSharedComponent } from './shared/activities-shared/activities-shared.component';
import { ActivitiesUnsharedComponent } from './shared/activities-unshared/activities-unshared.component';
import { ActivitiesUploadedComponent } from './shared/activities-uploaded/activities-uploaded.component';

@NgModule({
  imports: [SharedModule, DxDataGridModule, DevPopUpModule, PipesModule],
  declarations: [
    ActivitiesComponent,
    ActivitiesUploadedComponent,
    ActivitiesDownloadedComponent,
    ActivitiesRemovedComponent,
    ActivitiesUnsharedComponent,
    ActivitiesSharedComponent,
    ActivitiesPermissionChangedComponent,
    ActivitiesNavigateProfileComponent,
    ActivitiesDisplayPopupComponent,
  ],
  exports: [
    ActivitiesComponent,
    ActivitiesUploadedComponent,
    ActivitiesDownloadedComponent,
    ActivitiesRemovedComponent,
    ActivitiesUnsharedComponent,
    ActivitiesSharedComponent,
    ActivitiesPermissionChangedComponent,
    ActivitiesNavigateProfileComponent,
    ActivitiesDisplayPopupComponent,
  ],
  providers: [ActivitiesService],
})
export class ActivitiesModule {}
